import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';
import dateTimeHelper from '../Helpers/datetimeHelper';
import LookupText from '../Elements/LookupText';

export default class TpClientPaymentRefundItem {
  constructor(item) {
    if (!item) {
      this.TpClientPaymentRefundId = '';
      this.Reason = '';
      this.Amount = '';
      this.TransactionReference = '';
      this.Method = '';
      this.Comment = '';
      this.TpClientPaymentId = '';
      this.RefundedOn = '';
      this.CurrencyCode = '';
      return;
    }
    this.TpClientPaymentRefundId = item.tpClientPaymentRefundId;
    this.Reason = item.reason;
    this.Amount = item.amount;
    this.TransactionReference = item.transactionReference;
    this.Method = item.method;
    this.Comment = item.comment;
    this.TpClientPaymentId = item.tpClientPaymentId;
    this.RefundedOn = item.refundedOn;
    this.CurrencyCode = item.currencyCode;
  }

  static NameOfTheIdField() {
    return 'TpClientPaymentRefundId';
  }

  static nameOfTheItemDetailList(item) {
    if (item) return <span>Third-Party Client Payment Refund - {item.TpClientPaymentRefundId}</span>;
    return 'Client Payment Refund';
  }

  static MoneyFields = ['Amount'];

  static Currency() {
    return 'CurrencyCode';
  }

  static MoneyFieldsSecondary = ['Amount'];

  static CurrencySecondary() {
    return 'CurrencyCode';
  }

  static DateFields = ['RefundedOn'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-dollar-sign',
      data: [
        { name: 'TpClientPaymentId', label: 'Client Payment ID', className: 'text-left' },
        {
          name: (item) => (
            <LookupText
              lookupId={57}
              value={item.Reason}
            />
          ),
          label: 'Refund Reason',
          className: 'text-left',
        },
        { name: 'Amount', label: 'Amount', className: 'text-left' },
        {
          name: (item) => (item.RefundedOn ? dateTimeHelper.toYYYYsMMsDD(item.RefundedOn, '/') : ''),
          label: 'Refund Transaction Date',
          className: 'text-left',
        },
        {
          name: (item) => (
            <LookupText
              lookupId={58}
              value={item.Reason}
            />
          ),
          label: 'Refund Transaction Method',
          className: 'text-left',
        },
        { name: 'TransactionReference', label: 'Transaction Reference', className: 'text-left' },
        {
          name: 'Comment',
          label: 'Comment',
          className: 'text-left',
          width: TabListTableCellWidthEnum.TwoLines,
          contentHasHtml: true,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Refund ID',
        orderById: 'TpClientPaymentRefundId',
        data: 'TpClientPaymentRefundId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 50,
      },
      {
        label: 'Reason',
        orderById: 'Reason',
        data: (item) => (
          <LookupText
            lookupId={57}
            value={item.Reason}
          />
        ),
        minWidth: 50,
      },
      { label: 'Amount', orderById: 'Amount', data: 'Amount', minWidth: 50 },
      {
        label: 'Transaction Reference',
        orderById: 'TransactionReference',
        data: (item) => (
          <LongText
            text={item.TransactionReference}
            maxLength={100}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Method',
        orderById: 'Method',
        data: (item) => (
          <LookupText
            lookupId={58}
            value={item.Reason}
          />
        ),
        minWidth: 50,
      },
      {
        label: 'Comment',
        orderById: 'Comment',
        data: (item) => (
          <LongText
            text={item.Comment}
            maxLength={150}
          />
        ),
        minWidth: 100,
      },
    ];
  }
}
